module.exports = "https://img1.huilianyi.com/6/icon-notification-success.6edf8d414a.appcore.png";